import React from 'react'

export default () => (
  <svg
    version="1.1"
    height="100%"
    viewBox="0 0 1000 1000"
  >
    <g>
      <path d="M240.9,964.1l25.9,25.9l492.3-492.3l-0.4-0.4L271.6,10L246,35.6l461.7,461.7L240.9,964.1z" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/modules/icons/arrowIcon.jsx